const selecttWatchSettingsStore = (state) => state.watchSettings;

export const selectWatchSettingsData = (state) =>
  selecttWatchSettingsStore(state).data;
